import React, { useState, useEffect, useRef } from "react";


type props = {
    text: string,
    children: any,
    side: "left" | "right"
}

const Tooltip = ({text, children, side}: props) => {
    const [isOn, setIsOn] = useState(false);
    const [childWidth, setChildWidth] = useState(0);
    const childRef = useRef();

    useEffect(() => {
        if (childRef.current) {
            setChildWidth(childRef.current.children[0].offsetWidth);
        }
    }, [children])

    return (
        <>
            <div
                ref={childRef}
                style={{width: childWidth}}
                className="tooltipChild"
                onMouseEnter={() => setIsOn(true)}
                onMouseLeave={() => setIsOn(false)}
            >{children}
                <div className="tooltipWrapper"
                    style={{
                        display: isOn ? "block" : "none",
                        left: side === "right" && childWidth + 10,
                        right: side === "left" && childWidth + 10,
                        zIndex: "10000000000"
                    }}
                >
                    <p>{text}</p>
                </div>
            </div>
        </>
    )
}

export default Tooltip;